import { render, staticRenderFns } from "./DialogList.vue?vue&type=template&id=dfb8f124&scoped=true&"
import script from "./DialogList.vue?vue&type=script&lang=js&"
export * from "./DialogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb8f124",
  null
  
)

export default component.exports